import { Injectable } from '@angular/core';
import {
  BaseState,
  baseInitialState,
  AbstractBaseComponentStore,
} from '../../../../core/state/base-component-stores/abstract-base.component-store';
import { Observable, exhaustMap, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/component-store';
import { convertHttpErrorToApiError } from '../../../../shared/models/api-results/error.api-result';
import { ErrorService } from '../../../../core/services/error.service';
import { ToastrService } from 'ngx-toastr';
import { HttpEmailCommunicationService } from '../../../../core/services/http/http-email-communication.service';
import { ApplicationStats } from '../../../../shared/models/entities/application-stats.entity';
import { ApplicationStatsResult } from '../../../../shared/models/api-results/application-stats.api-result';
import { HttpApplicationStatsService } from '../../../../core/services/http/http-application-stats.service';
import { LoadingState } from '../../../../shared/models/interfaces/call-state.interface';

export enum LandingV2Properties {
  LOAD_APPLICATION_STATS = 'LOAD_APPLICATION_STATS',
}

export interface LandingV2State extends BaseState {
  applicationStats: ApplicationStatsResult;
}

export const initialState: LandingV2State = {
  ...baseInitialState,
  applicationStats: undefined,
};

@Injectable()
export class LandingV2StoreService extends AbstractBaseComponentStore<LandingV2State> {
  constructor(
    private toastr: ToastrService,
    private httpApplicationStats: HttpApplicationStatsService
  ) {
    super(initialState);
  }

  // SELECTORS

  applicationStats$ = this.select((state) =>
    state.applicationStats ? new ApplicationStats(state.applicationStats) : undefined
  );

  // ACTIONS

  getApplicationStatsSucceed = this.updater((state, result: ApplicationStatsResult) => {
    return {
      ...state,
      updatePropertyCallState: {
        ...state.updatePropertyCallState,
        [LandingV2Properties.LOAD_APPLICATION_STATS]: LoadingState.LOADED,
      },
      applicationStats: result,
    };
  });

  // EFFECTS

  getApplicationStats = this.effect<void>(
    pipe(
      tap(() => this.initUpdateProperty(LandingV2Properties.LOAD_APPLICATION_STATS)),
      exhaustMap(() =>
        this.httpApplicationStats.getApplicationStats().pipe(
          tapResponse(
            (result) => {
              this.getApplicationStatsSucceed(result);
            },
            (error) => {
              this.updatePropertyFailed({
                property: LandingV2Properties.LOAD_APPLICATION_STATS,
                error: convertHttpErrorToApiError(error),
              });
            }
          )
        )
      )
    )
  );
}
